import React from "react";
import { Navigate } from "react-router";
import { useAuth } from "../auth/useAuth";

interface PublicOnlyRouteProps {
  children: React.ReactElement;
}

const PublicOnlyRoute: React.FC<PublicOnlyRouteProps> = ({ children }) => {
  const { session, isLoading } = useAuth();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (session) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PublicOnlyRoute;
